const alarm = {
      "email": "Email",
      "sms": "SMS",
      "webPage": "Web",
      "alarmThreshold": "Порог тревоги",
      "repeatable": "Повторяющийся",
      "alarmNotice": "Заметка",
      "alarmConfig": "Конф. Тревоги",
      "halfDay": "Полдня",
      "aDay": "День",
      "twoDays": "2 дня",
      "threeDays": "3 дня",
      "descriptionRule": "Введите описание",
      "thresholdRule": "Введите порог",
      "fenceAlarm": "Тревога зоны",
      "integratorTip": "Интегратор демонстрирует только собственный список тревог",
      "selectedNum": "Введите номер записи",
      "search": "Поиск",
      "packUp": "Закрыть",
      "moreSearchType": "Дополнительно",
      "autoRecovery": "Авто восстановление",
      "ringType": "Тип звонка",
      "ringOnce": "Однократно",
      "ringAlways": "Всегда",
      "ringNone": "Никогда",
      "alarmSecondThreshold": "Макс. Порог",
      "围栏告警": "Нарушение зоны",
      "表带损坏告警": "Нарушение целостности",
      "异常开锁告警": "Несанкционированное снятие",
      "SOS告警": "SOS",
      "失联告警": "Вне зоны действия",
      "设备低电告警": "Предупреждение о низкой мощности оборудования",
      "跌倒告警": "Падение",
      "心率异常告警": "Неестественные данные пульса",
      "滞留告警": "Отсутствие движения",
      "隔离人员外出告警": "Выход из изоляции",
      手环佩戴:'Носить браслет тревоги',
      手环摘除:'Снять браслет тревога',
      lessThan:'Меньше',
      greaterThan:'Больше чем',
      optName:'Менеджеры',
      confirmTime:'Время обработки',
      annotation:'Обработка замечаний',
      心率异常:'Частота сердечных сокращений ненормальная',
      heartRateThresholdMin:'Введите целое число между 1 - 100!',
      heartRateThresholdMax:'Введите целое число от 100 до 200!',
      人员已删除:'Пользователь удален',
      体温异常告警:'Нормальная температура',
       上班打卡:'Начало рабочего дня',
      下班打卡:'Конец рабочего дня',
      超员告警:'Превышение лимита',
      SOS取消:'Снять SOS',
   }
export default alarm